<template>
  <tg-layout prefixCls="service">
    <tg-panel :title="$t('menu.service')">
      <div class="container">
        <el-row type="flex" v-for="(one, index) in serviceChannel" :key="index">
          <div class="service-item" @click="handleClick(one)">
            <p>
              <i :class="['tg-icon', 'tg-icon-' + one.item]"></i>
              <span>{{ one.displayName }}</span>
            </p>
          </div>
        </el-row>
      </div>
      <tg-dialog
        :showIcon="false"
        :title="title"
        :visible.sync="showDialog"
        append-to-body
        top="20vh"
        width="20%"
      >
        <el-row type="flex" justify="center" align="middle">
          <el-image :src="image" :alt="title" v-if="image">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>

          <span
            v-else
            style="text-align: center; font-size: 36px"
            class="text-red"
            v-html="$t('component.dialog.customer_service.fix')"
          >
          </span>
        </el-row>
      </tg-dialog>
    </tg-panel>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDialog from "@/components/dialog/TgDialog";
import TgPanel from "@/components/panel/TgPanel";

export default {
  components: {
    TgLayout,
    TgDialog,
    TgPanel,
  },
  computed: {
    serviceChannel() {
      return this.$store.state.service.serviceChannel;
    },
  },
  data() {
    return {
      title: "",
      showDialog: false,
      image: null,
    };
  },
  methods: {
    handleClick(item) {
      this.title = item.displayName;

      //openLink:
      // - 0:內嵌
      // - 1:開啟外部連結
      if (item.openLink == 0) {
        // 智能客服
        if (item.item == "serviceOnline24" || item.item == "serviceOnline12") {
          this.image = "";
          this.$store.dispatch("service/showService", this.$user);
        } else {
          this.image = item.serviceUrl;
          this.showDialog = true;
        }
      } else if (item.openLink == 1) {
        let link = document.createElement("a");
        link.target = "_blank";
        link.href = item.serviceUrl;
        link.click();
      }
    },
    getCustomClass(item) {
      let customClass = ["text-tg-icon" + item.item];

      return customClass;
    },
  },
};
</script>
